var Backbone, FAQHomeModel,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

FAQHomeModel = (function(superClass) {
  extend(FAQHomeModel, superClass);

  function FAQHomeModel() {
    return FAQHomeModel.__super__.constructor.apply(this, arguments);
  }

  FAQHomeModel.prototype.initialize = function() {
    return this.url = window.FAQBASEURL + "/home?should_display_cms_content=" + experiments.shouldDisplayCMSContentForUS;
  };

  return FAQHomeModel;

})(Backbone.Model);

module.exports = FAQHomeModel;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUva3VtYXJyYS9uYXBpc3RyYW5vL2J1aWxkLzE1MDQ3NzgxNDM1MjYtNzYxNzcvcHJvZHVjdGlvbi0yMDE3LjA5LjA3XzA5LjU0L3N1cHBvcnRfYXBwL21vZHVsZXMvZmFxL2Zyb250ZW5kL21vZGVscy9ob21lLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL2t1bWFycmEvbmFwaXN0cmFuby9idWlsZC8xNTA0Nzc4MTQzNTI2LTc2MTc3L3Byb2R1Y3Rpb24tMjAxNy4wOS4wN18wOS41NC9zdXBwb3J0X2FwcC9tb2R1bGVzL2ZhcS9mcm9udGVuZC9tb2RlbHMvaG9tZS5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQSxzQkFBQTtFQUFBOzs7QUFBQSxRQUFBLEdBQVcsT0FBQSxDQUFRLFVBQVI7O0FBRUw7Ozs7Ozs7eUJBQ0osVUFBQSxHQUFZLFNBQUE7V0FDVixJQUFDLENBQUEsR0FBRCxHQUFVLE1BQU0sQ0FBQyxVQUFSLEdBQW1CLG1DQUFuQixHQUFzRCxXQUFXLENBQUM7RUFEakU7Ozs7R0FEYSxRQUFRLENBQUM7O0FBSXBDLE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
